import { Dispatch, SetStateAction } from "react";
import ChartTimeframe from "./ChartTimeframe";
import ChartType from "./ChartType";
import "./ChartSettings.css";

interface ChartSettingsProps {
  chartType: "line" | "candlestick" | "histogram";
  setChartType: Dispatch<SetStateAction<"line" | "candlestick" | "histogram">>;
}

const ChartSettings: React.FC<ChartSettingsProps> = ({
  chartType,
  setChartType,
}) => {
  return (
    <div className="chart-settings">
      <div className="chart-settings__item">
        <p className="chart-settings__label">Time:</p>
        <ChartTimeframe />
      </div>

      <div className="chart-settings__item">
        <p className="chart-settings__label">View:</p>
        <ChartType chartType={chartType} setChartType={setChartType} />
      </div>
    </div>
  );
};

export default ChartSettings;
